// extracted by mini-css-extract-plugin
module.exports = {"wrap":"GXav","imgBg":"GXabf","image":"GXob","textBox":"GXabh","title":"GXal"};